import { render } from "./MatchinPayReload.vue?vue&type=template&id=ee07e9fc&ts=true"
import script from "./MatchinPayReload.vue?vue&type=script&lang=ts"
export * from "./MatchinPayReload.vue?vue&type=script&lang=ts"

import "./MatchinPayReload.vue?vue&type=style&index=0&id=ee07e9fc&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__